import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

// Lazy load pages
const HomePage = lazy(() => import('../pages/home/page'));
const FuncionalidadesPage = lazy(() => import('../pages/funcionalidades/page'));
const FuncionalidadeDetailPage = lazy(() => import('../pages/funcionalidades/detail/page'));
const PlanosPage = lazy(() => import('../pages/planos/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const BlogDetailPage = lazy(() => import('../pages/blog/detail/page'));
const FAQPage = lazy(() => import('../pages/faq/page'));
const SitemapPage = lazy(() => import('../pages/sitemap/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

// Admin pages
const AdminLoginPage = lazy(() => import('../pages/admin/login/page'));
const AdminRecuperarSenhaPage = lazy(() => import('../pages/admin/recuperar-senha/page'));
const AdminRedefinirSenhaPage = lazy(() => import('../pages/admin/redefinir-senha/page'));
const AdminDashboardPage = lazy(() => import('../pages/admin/dashboard/page'));
const AdminBlogPage = lazy(() => import('../pages/admin/blog/page'));
const AdminBlogNovoPage = lazy(() => import('../pages/admin/blog/novo/page'));
const AdminBlogEditarPage = lazy(() => import('../pages/admin/blog/editar/page'));
const AdminDepoimentosPage = lazy(() => import('../pages/admin/depoimentos/page'));
const AdminDepoimentosNovoPage = lazy(() => import('../pages/admin/depoimentos/novo/page'));
const AdminDepoimentosEditarPage = lazy(() => import('../pages/admin/depoimentos/editar/page'));
const AdminFAQsPage = lazy(() => import('../pages/admin/faqs/page'));
const AdminFAQsNovoPage = lazy(() => import('../pages/admin/faqs/novo/page'));
const AdminFAQsEditarPage = lazy(() => import('../pages/admin/faqs/editar/page'));
const AdminAuditoriaPage = lazy(() => import('../pages/admin/auditoria/page'));

// SEO Landing Pages
const SistemaEmissaoCTePage = lazy(() => import('../pages/seo-landing/sistema-emissao-cte/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/funcionalidades',
    element: <FuncionalidadesPage />,
  },
  {
    path: '/funcionalidades/:slug',
    element: <FuncionalidadeDetailPage />,
  },
  {
    path: '/planos',
    element: <PlanosPage />,
  },
  {
    path: '/blog',
    element: <BlogPage />,
  },
  {
    path: '/blog/:slug',
    element: <BlogDetailPage />,
  },
  {
    path: '/faq',
    element: <FAQPage />,
  },
  {
    path: '/sitemap',
    element: <SitemapPage />,
  },
  // SEO Landing Pages
  {
    path: '/sistema-emissao-cte',
    element: <SistemaEmissaoCTePage />,
  },
  {
    path: '/software-transportadora',
    element: <SistemaEmissaoCTePage />,
  },
  {
    path: '/emissor-cte',
    element: <SistemaEmissaoCTePage />,
  },
  // Admin routes
  {
    path: '/admin',
    element: <AdminDashboardPage />,
  },
  {
    path: '/admin/login',
    element: <AdminLoginPage />,
  },
  {
    path: '/admin/recuperar-senha',
    element: <AdminRecuperarSenhaPage />,
  },
  {
    path: '/admin/redefinir-senha',
    element: <AdminRedefinirSenhaPage />,
  },
  {
    path: '/admin/dashboard',
    element: <AdminDashboardPage />,
  },
  {
    path: '/admin/blog',
    element: <AdminBlogPage />,
  },
  {
    path: '/admin/blog/novo',
    element: <AdminBlogNovoPage />,
  },
  {
    path: '/admin/blog/editar/:id',
    element: <AdminBlogEditarPage />,
  },
  {
    path: '/admin/depoimentos',
    element: <AdminDepoimentosPage />,
  },
  {
    path: '/admin/depoimentos/novo',
    element: <AdminDepoimentosNovoPage />,
  },
  {
    path: '/admin/depoimentos/editar/:id',
    element: <AdminDepoimentosEditarPage />,
  },
  {
    path: '/admin/faqs',
    element: <AdminFAQsPage />,
  },
  {
    path: '/admin/faqs/novo',
    element: <AdminFAQsNovoPage />,
  },
  {
    path: '/admin/faqs/editar/:id',
    element: <AdminFAQsEditarPage />,
  },
  {
    path: '/admin/auditoria',
    element: <AdminAuditoriaPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
